// extracted by mini-css-extract-plugin
export default {"view-port-full":"100%","view-port-large":"80rem","view-port-medium":"55rem","view-port-small":"40rem","view-port-xs":"30rem","view-port-xxs":"20rem"};